interface Props {
  isOpen: boolean;
}

export default function OpenIcon({ isOpen }: Props) {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={12.5} cy={12.5} r={12.5} fill="url(#paint0_linear_0_1)" />
      <path
        d="M5.44736 13.366C4.78069 12.9811 4.78069 12.0189 5.44736 11.634L15.2763 5.95923C15.943 5.57433 16.7763 6.05545 16.7763 6.82525L16.7763 18.1747C16.7763 18.9445 15.943 19.4257 15.2763 19.0408L5.44736 13.366Z"
        fill="white"
        className={isOpen ? '' : 'origin-center rotate-180'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_0_1"
          x1={0}
          y1={12.5}
          x2={25}
          y2={12.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF426F" />
          <stop offset={1} stopColor="#514689" />
        </linearGradient>
      </defs>
    </svg>
  );
}
